<template>
  <div class="regPage">
    <el-form :model="regInfo" :rules="rules" ref="regInfo" class="regForm" label-width="80px">
        <el-form-item class="infoInput" prop="email" label="邮箱地址" :error="errorMsg" >
          <el-input v-model="regInfo.email"  v-if="emaiStatus==0" class="emailAddr" maxlength="25">
          </el-input>
          <span v-text="regInfo.email"  v-if="emaiStatus==1" class="emailAddrText" > </span>
            <el-select v-model="regInfo.email" v-if="emaiStatus == 2" placeholder="请选择" class="emailAddr">
              <el-option
                v-for="(item, index) in userPrincipalName"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            <span class="emailName">@alumni.tongji.edu.cn</span>
          <p class="tips"> 2~18个字符，可使用字母、数字、下划线，不能为纯数字</p>
        </el-form-item>
         <el-form-item class="infoInput" label="别名" v-if="regInfo.aliasStr != '' ">
           <el-input v-model="regInfo.aliasStr" readonly="true" maxlength="25"></el-input>
            <p class="tips"></p>
        </el-form-item>
        <el-form-item class="infoInput" :class="{pwd:regInfo.aliasStr !='' }" prop="pwd" label="密码">
            <el-input v-model="regInfo.pwd" type="password" placeholder="请输入" maxlength="25"></el-input>
            <p class="tips"> 8-16个字符且至少包含三种字符：大写字母、小写字母、符号和数字</p>
        </el-form-item>
        <el-form-item class="infoInput " prop="pwd2" label="确认密码">
            <el-input v-model="regInfo.pwd2" type="password" placeholder="确认密码" maxlength="25"></el-input>
            <p class="tips"> 请再次填写密码</p>
        </el-form-item>
        <el-form-item class="infoBtn" >
            <el-button type="primary" @click="regEmail()">注册邮箱</el-button>
        </el-form-item>
    </el-form>
    <!-- 消息提示栏 -->
    <el-dialog
      :visible.sync="successInfo"
      custom-class="showBox"
      width="467px"
      :close-on-click-modal="boxCloseInfo"
      :close-on-press-escape="boxCloseInfo"
      :show-close="boxCloseInfo"
      center>
      <span class="boxTitle">亲爱的校友:</span>
      <p class="boxBody">恭喜您! <span class="emilName">{{regInfo.email}}@alumni.tongji.edu.cn </span>  邮箱已经注册成功</p>
      <span slot="footer" class="dialog-footer">
        <a href="https://login.partner.microsoftonline.cn" class="boxBtn" type="primary">开始使用</a>
      </span>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: "regForm",
  props: ['userInfo'],
  data() {
  const PwdPatrn = (str) => {
    const reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/;
    return reg.exec(str);
}
var PwdPatrn2 = str =>{
  const reg = this.regInfo.email;
  const reg2 =reg.toLowerCase();
  const str2 = str.toLowerCase();
  return str2.indexOf(reg2);
}
   var checkEmail = (rule, value, callback) =>{
    var  email = /^[a-zA-Z0-9_][a-zA-Z0-9_]*$/;
    var  number = /^[0-9]*$/
    if (value === '') {
      return callback(new Error('邮箱地址不能为空'));
    }else if(this.emaiStatus != 0){
        callback();
    }else{

            if (!email.test(value)) {
              callback(new Error('请按要求填写邮箱地址'));
            } else {
              if(number.test(value)){
                callback(new Error('邮箱地址不能为纯数字'));
              }else{
                callback();
              }
            }

          }
  }
    var checkPwd = (rule, value, callback) => {
      const regPWD = /&/;
      const regPWD2 = /\s/;
			if (value === '') {
				callback(new Error('请输入密码'));
			} else if (!PwdPatrn(value)) {
				callback(new Error('密码格式不正确'));
      } else if (regPWD.test(value)) {
				callback(new Error('密码格式不正确'));
      } else if (regPWD2.test(value)) {
				callback(new Error('密码格式不正确'));
      }else if(PwdPatrn2(value)!="-1"){
        callback(new Error("密码不能包含邮箱地址"));
      } else{
				if (this.regInfo.pwd2 !== '') {
          this.$refs.regInfo.validateField('pwd2');
				}
				callback();
			}
		};
  var checkPwd2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.regInfo.pwd) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		}
    return {
        successInfo:false,
        boxCloseInfo:false,
        emaiStatus:false,
        errorMsg:"",
        userInfos:"",
        regInfo: {
          email:'',
          pwd:'',
          pwd2:'',
          student_id: "",
          student_identification: "",
          alias: [],
          aliasStr:"",
          name:"",
        },
        rules: {
            email: [
              { validator: checkEmail, trigger: 'change' },
              {min: 2,max: 18,message: '邮箱长度在 2 到 18 个字符',trigger: 'change'}
            ],
            pwd: [
              { validator: checkPwd, trigger: 'change' },
              {min: 8,max: 16,message: '密码长度在 8 到 16 个字符',trigger: 'change'}
            ],
            pwd2: [
              { validator: checkPwd2, trigger: 'change' }
            ],
          },

    };
  },

  methods: {
      //注册
      regEmail(regInfo){
        let self = this
        const phoneNo = sessionStorage.getItem("officeEmail_phoneNo")
        const name = sessionStorage.getItem("officeEmail_name")
        self.$refs['regInfo'].validate((valid) => {
          if(valid){
                            const loading = this.$loading({
                              lock: true,
                              text: '正在注册中...',
                              spinner: 'el-icon-loading',
                              background: 'rgba(0, 0, 0, 0.7)'
                            });
                            self.errorMsg =""
                            const officeEmail = self.regInfo.email
                            const alias = self.regInfo.alias
                            const password = self.regInfo.pwd
                            const token = self.md5(sessionStorage.getItem('officeEmail_token'))
                            const url = '/email/regiterOfficeemail'
                            const _params = {
                              "officeMail":officeEmail,
                              "alias":alias,
                              "name":name,
                              "phoneNo":phoneNo,
                              "password":password,
                              "token":token
                            }
                            const params = JSON.stringify(_params)

                        self.postRequest(url,params).then((result)=>{
                            console.log(result.data)
                            loading.close();

                            if(result.data.msgStatus == 1){
                                self.successInfo = true
                                //5,清除数据-----只清空当前会话存储的数据
                                sessionStorage.clear();
                            }else if(result.data.msgStatus == 3){
                                self.errorMsg = "校友邮箱地址已存在"
                            }else if(result.data.msgStatus == 4){
                                self.$alert(result.data.msgCode, '错误提示', {
                                  confirmButtonText: '确定',
                                  type: 'error',
                                  center: true,
                                  customClass:'errMessage'
                                });
                            }else if(result.data.msgStatus == 100){
                                self.$alert("会话超时，请重新进行身份验证", '错误提示', {
                                  confirmButtonText: '确定',
                                  type: 'error',
                                  center: true,
                                  customClass:'errMessage',
                                  callback: self.$router.push({ name: 'checkPhone'})
                                });
                                //5,清除数据-----只清空当前会话存储的数据
                                  sessionStorage.clear();
                            }else{
                                self.$alert("系统错误,请重试", '错误提示', {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true,
                                customClass:'errMessage'
                                });
                            }
              })

          }
        })
      },

  },
  mounted() {
    const self = this
    var newArr = [];
    const userInfo = JSON.parse(sessionStorage.getItem("officeEmail_userInfo"))
    self.userInfos = userInfo;
    userInfo.forEach(item => {

       newArr.push( item.person_sid);
    })
       console.log(newArr)
    self.regInfo.alias = newArr;
    var str1 = "";  
    for (let i = 0; i < newArr.length; i++) {
          if (i < newArr.length - 1) {
            str1 += newArr[i] + ",";
          } else {
            str1 += newArr[i];
          }
        }

    self.regInfo.aliasStr = str1;
    // self.regInfo.aliasStr = "";

    // if(userInfo.sids.indexOf(",")=="-1"){
    //   self.regInfo.alias.push(userInfo.sids)
    // }else{
    //    self.regInfo.alias = userInfo.sids.split(",")
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.regForm {
  margin-top: 38px;
}
.emilName{
  color: #eb5468;
  font-size: 20px;
}
.emailAddr{
  width: 215px;
}
.emailAddrText{
    display: inline-block;
    border: 1px solid #dcdfe6;
    width: 205px;
    text-align: left;
    text-indent: 1em;
    margin-right: 7px;
    line-height: 38px;
}
.emailName{
    display: inline-block;
    border: 1px solid #dcdfe6;
    width: 170px;
    text-align: center;
    margin-left: -12px;
    line-height: 38px;
  }
.infoInput {
  width: 460px;
  height: 41px;
  margin: 0 auto;
  margin-top: 55px;
}
.infoInput.pwd{
  margin-top: 25px;
}
.tips{
    padding: 0;
    line-height: 25px;
    color: #999;
    font-size: 12px;
}
  .infoBtn{
    margin: 0 auto;
    margin-top: 80px;
    text-align: center;
  }
  .infoBtn button{
    width: 310px;
  }
 .showBox .boxTitle{
     display: block;
     font-size: 20px;
     color: #778085;
     margin-left: 31px;
  }
  .showBox .boxBody{
     font-size: 16px;
     color: #778085;
     padding: 0 31px;
     word-break:break-all;
  }
  .showBox .boxBtn{
    display: block;
    width: 395px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    margin-bottom: 30px;
    background: #198bfd;
    color: #fff;
  }
.showBox .boxBtn:hover{
  background: #66b1ff;
}
</style>



// WEBPACK FOOTER //
// src/page/officialEmail/reg/form.vue